export default {
  mapQueries: [],
  mapQuery: undefined,
};
